import memoize from 'lodash/memoize';

import FeatureGates from '@atlaskit/feature-gate-js-client';
import { fg } from '@atlaskit/platform-feature-flags';
import { STATSIG_ROVO_SEARCH_QF_EXPERIENCE_LAYER } from '@atlassian/search-experiment';

import {
	getJiraUIExperienceLayerFrontendExperiment,
	hasSAINHelloLayerParamValue,
	hasSAINLayerParamValue,
} from './get-sain-layer-frontend-experiment';

const canRenderLuminaUnmemoized = (): boolean => {
	if (fg('kd_dynamic_layout_in_sain')) {
		return true;
	}

	return false;
};

const isBorderlessUXEnabledUnmemoized = (): boolean => {
	if (hasSAINHelloLayerParamValue('LuminaInSAIN', 'test')) {
		return true;
	}

	if (hasSAINLayerParamValue('LuminaInSAIN', 'test')) {
		return true;
	}

	return false;
};

const isSourcesInShortSAINAnswersEnabledUnmemoized = () => {
	if (fg('kd_sain_show_sources_in_short_answers')) {
		return true;
	}

	return hasSAINLayerParamValue('sourcesInShortSAINAnswers', 'test');
};

const isThirdPartyBannerEnabledUnmemoized = () => {
	if (fg('rovo_search_3p_banner_opt_out') || SAINFeatureControl.isBorderlessUXEnabled()) {
		return false;
	}
	if (fg('kd_sain_show_third_party_banner')) {
		return true;
	}

	return (
		hasSAINLayerParamValue('SAINThirdPartyBanner', 'test') ||
		hasSAINHelloLayerParamValue('SAINThirdPartyBanner', 'test')
	);
};

const isZeroQuerySuggestionsV1EnabledUnmemoized = (isHello: boolean) => {
	if (isHello) {
		return true;
	}

	const layer = FeatureGates.getLayer(STATSIG_ROVO_SEARCH_QF_EXPERIENCE_LAYER);
	const customersEnabled = layer.get<boolean>('isZeroQuerySuggestionsV1Enabled', false);
	return customersEnabled;
};

const isFullHeightLuminaEnabledUnmemoized = (): boolean => {
	if (fg('kd_enable_full_height_lumina')) {
		return true;
	}
	return false;
};

const isJiraSAINCardSmartLinkEnabledUnmemoized = ({
	sourceProduct,
}: {
	sourceProduct: string | undefined;
}): boolean => {
	const { serveExperiment: serveJiraFPSNLQNavigationExperiment } =
		getJiraUIExperienceLayerFrontendExperiment({
			abTestId: 'rovo_jira_nin_fps_nlq_navigation_exp',
		});

	if (
		sourceProduct === 'jira' &&
		(fg('kd_jira_sain_card_smartlink_fg') || serveJiraFPSNLQNavigationExperiment)
	) {
		return true;
	}

	return false;
};

export const SAINFeatureControl = {
	/** Controls whether frontend can parse and render lumina-formatted answers */
	canRenderLumina: memoize(canRenderLuminaUnmemoized),
	/** Controls the borderless UX experiment (visual design refresh) */
	isBorderlessUXEnabled: memoize(isBorderlessUXEnabledUnmemoized),
	isFullHeightLuminaEnabled: memoize(isFullHeightLuminaEnabledUnmemoized),
	isSourcesInShortSAINAnswersEnabled: memoize(isSourcesInShortSAINAnswersEnabledUnmemoized),
	isThirdPartyBannerEnabled: memoize(isThirdPartyBannerEnabledUnmemoized),
	isZeroQuerySuggestionsV1Enabled: memoize(isZeroQuerySuggestionsV1EnabledUnmemoized),
	isJiraSAINCardSmartLinkEnabled: memoize(isJiraSAINCardSmartLinkEnabledUnmemoized),
};
